import { render, staticRenderFns } from "./Instrument.vue?vue&type=template&id=489ed63a&"
import script from "./Instrument.vue?vue&type=script&lang=js&"
export * from "./Instrument.vue?vue&type=script&lang=js&"
import style0 from "./Instrument.vue?vue&type=style&index=0&id=489ed63a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports